import { render, staticRenderFns } from "./OfferTile.vue?vue&type=template&id=50ef5488&scoped=true&"
import script from "./OfferTile.vue?vue&type=script&lang=js&"
export * from "./OfferTile.vue?vue&type=script&lang=js&"
import style0 from "./OfferTile.vue?vue&type=style&index=0&id=50ef5488&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef5488",
  null
  
)

export default component.exports